// Berichte / Reports (Agent 7A, Runde 7): Aktivitätsübersicht mit Kacheln, Vergleich der Nutzer, Anrufe, Statuswechsel, Opportunity-Trichter,
// gesendete E-Mails und gespeicherte Berichte (R-01 bis R-16). Die Route ist `/reports/*`; die Bausteine liegen in `src/berichte/`,
// der Client in `src/api/berichte.ts`, die Routen stehen in API.md 22.1.
import { Navigate, Route, Routes } from "react-router-dom";
import { Anrufe } from "../berichte/Anrufe";
import { BerichteStart } from "../berichte/BerichteStart";
import { Gesendet } from "../berichte/Gesendet";
import { Statuswechsel } from "../berichte/Statuswechsel";
import { Trichter } from "../berichte/Trichter";
import { Vergleich } from "../berichte/Vergleich";

export default function Berichte() {
  return (
    <Routes>
      <Route index element={<BerichteStart />} />
      <Route path="vergleich" element={<Vergleich />} />
      <Route path="anrufe" element={<Anrufe />} />
      <Route path="statuswechsel" element={<Statuswechsel />} />
      <Route path="trichter" element={<Trichter />} />
      <Route path="gesendet" element={<Gesendet />} />
      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
}
